import {
  ARTIST,
  ARTIST_DETAIL,
  AWARD,
  AWARD_CREATE,
  AWARD_DETAIL,
  AWARD_MODIFY,
  AWARD_VIDEO,
  FAQ,
  FAQ_CREATE,
  FAQ_DETAIL,
  FAQ_MODIFY,
  MEDIA,
  MEDIA_CREATE,
  MEDIA_DETAIL,
  MEDIA_MODIFY,
  NEWS,
  NEWS_CREATE,
  NEWS_DETAIL,
  NEWS_MODIFY,
  PARTNER,
  PARTNER_CREATE,
  PARTNER_DETAIL,
  PARTNER_MODIFY,
  PROJECT,
  PROJECT_DETAIL,
  WEBINAR,
  WEBINAR_CREATE,
  WEBINAR_DETAIL,
  WEBINAR_MODIFY,
} from "@constants/routes";

import DetailArtist from "@pages/Artist/DetailArtist";
import ListArtist from "@pages/Artist/ListArtist";
import AwardVideo from "@pages/Award/AwardVideo";
import CreateAward from "@pages/Award/CreateAward";
import DetailAward from "@pages/Award/DetailAward";
import ListAwards from "@pages/Award/ListAward";
import ModifyAward from "@pages/Award/ModifyAward";
import CreateFaq from "@pages/Faq/CreateFaq";
import DetailFaq from "@pages/Faq/DetailFaq";
import ListFaqs from "@pages/Faq/ListFaq";
import ModifyFaq from "@pages/Faq/ModifyFaq";
import CreateMedia from "@pages/Media/CreateMedia";
import DetailMedia from "@pages/Media/DetailMedia";
import ListMedia from "@pages/Media/ListMedia";
import ModifyMedia from "@pages/Media/ModifyMedia";
import CreateNews from "@pages/News/CreateNews";
import DetailNews from "@pages/News/DetailNews";
import ListNews from "@pages/News/ListNews";
import ModifyNews from "@pages/News/ModifyNews";
import CreatePartner from "@pages/Partner/CreatePartner";
import DetailPartner from "@pages/Partner/DetailPartner";
import ListPartners from "@pages/Partner/ListPartner";
import ModifyPartner from "@pages/Partner/ModifyPartner";
import DetailProject from "@pages/Project/DetailProject";
import ListProject from "@pages/Project/ListProject";
import CreateWebinar from "@pages/Webinar/CreateWebinar";
import DetailWebinar from "@pages/Webinar/DetailWebinar";
import ListWebinars from "@pages/Webinar/ListWebinar";
import ModifyWebinar from "@pages/Webinar/ModifyWebinar";
import { Route, Switch } from "react-router-dom";

const Modules = () => (
  <Switch>
    <Route exact path={PARTNER} component={ListPartners} />
    <Route exact path={PARTNER_DETAIL} component={DetailPartner} />
    <Route exact path={PARTNER_CREATE} component={CreatePartner} />
    <Route exact path={PARTNER_MODIFY} component={ModifyPartner} />

    <Route exact path={FAQ} component={ListFaqs} />
    <Route exact path={FAQ_DETAIL} component={DetailFaq} />
    <Route exact path={FAQ_CREATE} component={CreateFaq} />
    <Route exact path={FAQ_MODIFY} component={ModifyFaq} />

    <Route exact path={NEWS} component={ListNews} />
    <Route exact path={NEWS_DETAIL} component={DetailNews} />
    <Route exact path={NEWS_CREATE} component={CreateNews} />
    <Route exact path={NEWS_MODIFY} component={ModifyNews} />

    <Route exact path={WEBINAR} component={ListWebinars} />
    <Route exact path={WEBINAR_DETAIL} component={DetailWebinar} />
    <Route exact path={WEBINAR_CREATE} component={CreateWebinar} />
    <Route exact path={WEBINAR_MODIFY} component={ModifyWebinar} />

    <Route exact path={ARTIST} component={ListArtist} />
    <Route exact path={ARTIST_DETAIL} component={DetailArtist} />

    <Route exact path={AWARD} component={ListAwards} />
    <Route exact path={AWARD_DETAIL} component={DetailAward} />
    <Route exact path={AWARD_CREATE} component={CreateAward} />
    <Route exact path={AWARD_MODIFY} component={ModifyAward} />
    <Route exact path={AWARD_VIDEO} component={AwardVideo} />

    <Route exact path={PROJECT} component={ListProject} />
    <Route exact path={PROJECT_DETAIL} component={DetailProject} />

    <Route exact path={MEDIA} component={ListMedia} />
    <Route exact path={MEDIA_DETAIL} component={DetailMedia} />
    <Route exact path={MEDIA_CREATE} component={CreateMedia} />
    <Route exact path={MEDIA_MODIFY} component={ModifyMedia} />
  </Switch>
);

export default Modules;
